export default "__VITE_ASSET__BZBo36as__"